import React from 'react';

export const PublishProfileToggle = props => {
    const {visible, handleToggle, experience, summary, openWarningModal} = props;
    const noSummaryAndExperience = ( (summary.noData) || (!experience) );
    //console.log( 'LOG: noSUmmaryAndExperience', noSummaryAndExperience, summary.noData, experience.body.length === 0 );
    return (
        <div className="row">
            <div className="col-xs-8 col-md-9">
                { visible ?
                    <p className="p-tag">Your profile is published on <b>InTouch Networks</b>. Any changes you make will be
                        immediately made <b>visible to other users</b>.</p>
                    :
                    <p className="p-tag">Your profile is not published on <b>InTouch Networks</b>, which means <b>no one but you
                        can see it</b>.</p>
                }
            </div>
            <div className="col-xs-4 col-md-3">
                {
                    noSummaryAndExperience ?
                        <span>
                            { (visible === 1) ?
                                <button className={`btn-toggle${ visible ? ' toggle-on' : ' toggle-off'}`}
                                        onClick={ () => handleToggle(visible ? 0 : 1) }>
                                    { visible ? 'on' : 'off' } <span className="dot"/>
                                </button>
                                :
                                <button className={`btn-toggle${ visible ? ' toggle-on' : ' toggle-off'}`}
                                        onClick={ () => openWarningModal() }>
                                    { visible ? 'on' : 'off' }
                                    <span className="dot"/>
                                </button>
                            }
                        </span>
                        :
                        <button className={`btn-toggle${ visible ? ' toggle-on' : ' toggle-off'}`}
                                onClick={ () => handleToggle(visible ? 0 : 1) }>
                            { visible ? 'on' : 'off' } <span className="dot"/>
                        </button>
                }

            </div>
        </div>
    )
};




// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/visibility/PublishProfileToggle.js